import { Attributes, List, LookupBase, Misc, Rules, Validation } from '@singularsystems/neo-core';
import { IAuthorisable } from '../IAuthorisable';
import TemporalEntity from '../TemporalEntity';
import AuthorisationValues from '../ValueObjects/AuthorisationValues';
import InvestorUser from '../Investors/InvestorUser';

export default class PortalUser extends TemporalEntity implements IAuthorisable {

    static typeName = "PortalUser";

    constructor() {
        super();
        this.makeObservable();
    }

    public portalUserId: number = 0;

    @Rules.Required()
    @Rules.StringLength(200)
    public firstName: string = "";

    @Rules.Required()
    @Rules.StringLength(200)
    public lastName: string = "";

    @Rules.Required()
    @Rules.StringLength(200)
    public loginName: string = "";

    @Attributes.Nullable()
    public contactId: number | null = null;

    public isActive: boolean = true;

    @Attributes.Nullable()
    public userGroupId: number | null = null;

    @Attributes.Date()
    public termsAndConditionsAcceptedOn: Date | null = null;

    @Attributes.ChildObject(AuthorisationValues, true)
    public authorisation: AuthorisationValues = new AuthorisationValues();

    public isPendingDelete: boolean = false;

    public isAdminPortal: boolean = true;

    @Attributes.NoTracking(Misc.SerialiseType.FullOnly)
    public lookup: LookupFields = new LookupFields();

    public investors = new List(InvestorUser);

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew) {
            return "New Portal User";
        } else {
            return "Portal User";
        }
    }
}

export class LookupFields extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public emailAddress: string | null = null;

    public contactName: string | null = null;

    // Client only properties / methods
}